<template>
  <div
    class="border-gray-200 sticky bottom-0 z-50 flex bg-white"
    :class="{
      'flex-row gap-4 p-4 sm:px-0 sm:py-4': isAddToBasketPopover,
      'flex-col border-t p-4': !isAddToBasketPopover,
      'pb-14': isAddToBasketPopover && isSafari && isMobile,
    }"
    @click.capture="$emit('close')"
  >
    <!-- Add-to-basket overlay, desktop (ECOM-2723, Leap winner V3). The variant
         replaces "Weiter einkaufen" with a prominent "Zur Kasse" and demotes
         "Warenkorb" to outlined — the overlay is left with two CTAs and no
         continue-shopping affordance; the modal's close button covers that. -->
    <template v-if="isAddToBasketPopover && isDesktop">
      <NuxtLink
        :to="toLocalePath({ name: 'basket' })"
        class="flex w-full items-center justify-center border border-black bg-white p-3 text-center text-sm font-medium uppercase text-black"
        data-qa="show-cart"
        @click.prevent="handleClick('basket')"
        >{{ $t('basket.heading') }}</NuxtLink
      >
      <NuxtLink
        :to="toLocalePath({ name: 'checkout' })"
        class="flex w-full items-center justify-center bg-primary p-3 text-center text-sm font-bold uppercase text-white"
        data-qa="go-to-checkout"
        @click.prevent="handleClick('checkout')"
        >{{ $t('basket.checkout_label') }}</NuxtLink
      >
    </template>
    <Button
      v-if="isAddToBasketPopover && !isDesktop"
      type="tertiary"
      class="w-full cursor-pointer border border-black bg-white text-center text-sm uppercase text-black"
      data-qa="go-to-checkout"
      @click.capture="$emit('close')"
      >{{ $t('wishlist.continue_shopping_label') }}</Button
    >
    <NuxtLink
      v-if="!isAddToBasketPopover"
      :to="toLocalePath({ name: 'checkout' })"
      class="w-full bg-primary p-2 text-center text-sm font-bold uppercase text-white"
      data-qa="go-to-checkout"
      @click.prevent="handleClick('checkout')"
      >{{ $t('basket.checkout_label') }}</NuxtLink
    >
    <NuxtLink
      v-if="!(isAddToBasketPopover && isDesktop)"
      :to="toLocalePath({ name: 'basket' })"
      class="flex w-full items-center justify-center p-2 text-center text-sm uppercase"
      :class="{
        'bg-primary font-bold text-white': isAddToBasketPopover,
        'mt-4 border border-black bg-white text-black': !isAddToBasketPopover,
      }"
      data-qa="show-cart"
      @click.prevent="handleClick('basket')"
      >{{ $t('basket.heading') }}</NuxtLink
    >
  </div>
</template>

<script setup lang="ts">
import useRouteHelpers from '#layers/base/composables/useRouteHelpers'
import useGoldnerClub from '~/composables/useGoldnerClub'
import useBrowserDetection from '#layers/base/composables/useBrowserDetection'

const { getMembershipDetails } = useGoldnerClub()
const router = useRouter()
const { isSafari } = useBrowserDetection()
const { isMobile } = useDeviceType()

defineProps({
  isAddToBasketPopover: Boolean,
  isDesktop: Boolean,
})
const { toLocalePath } = useRouteHelpers()

const handleClick = async (routeName: 'basket' | 'checkout') => {
  await getMembershipDetails()

  await router.push(toLocalePath({ name: routeName }))
}

defineEmits(['close'])
</script>
